import React from 'react';
import clsx from 'clsx';

type FieldProps = {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
};

export const Field: React.FC<FieldProps> = ({
  label,
  helperText,
  error,
  required,
  className,
  children,
}) => {
  return (
    <div className={clsx('w-full space-y-1', className)}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 text-right">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="mt-1">{children}</div>

      {helperText && !error && (
        <p className="text-sm text-gray-500 text-right">{helperText}</p>
      )}
      {error && (
        <p className="text-sm text-red-600 text-right" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};
